import { Link } from "react-router-dom";

export const Crown = ({ className = "w-8 h-6" }) => (
  <svg viewBox="0 0 64 40" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="crownGold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#F3E5AB" />
        <stop offset=".5" stopColor="#D4AF37" />
        <stop offset="1" stopColor="#A8841F" />
      </linearGradient>
    </defs>
    <path d="M6 14l13 10L32 4l13 20 13-10-5 20H11z" fill="url(#crownGold)" />
    <circle cx="6" cy="12" r="3.4" fill="#E02575" />
    <circle cx="32" cy="4" r="3.4" fill="#0FA3A3" />
    <circle cx="58" cy="12" r="3.4" fill="#F25A1F" />
    <rect x="11" y="35" width="42" height="4" rx="2" fill="url(#crownGold)" />
  </svg>
);

export const Logo = ({ size = "md", tone = "dark", testId = "site-logo" }) => {
  const big = size === "lg";
  const sub = tone === "dark" ? "text-plum" : "text-cream";
  return (
    <Link to="/" data-testid={testId} className="group inline-flex flex-col items-center leading-none select-none">
      <span className={`relative font-display font-black tracking-tight ${big ? "text-6xl sm:text-7xl" : "text-[2.1rem] sm:text-[2.6rem]"} ${tone === "dark" ? "text-plum" : "text-cream"}`}>
        <Crown className={`absolute left-1/2 -translate-x-[18%] ${big ? "-top-7 w-12 h-8" : "-top-4 w-7 h-5"} transition-transform duration-500 group-hover:-translate-y-1 group-hover:rotate-[-6deg]`} />
        LU<span className="x-gradient italic">X</span>E
      </span>
      <span className={`mt-1 font-display uppercase ${big ? "text-base tracking-[0.55em]" : "text-[9px] sm:text-[10px] tracking-[0.5em]"} ${sub} pl-[0.5em]`}>
        Dream Market
      </span>
    </Link>
  );
};

export const Monogram = ({ className = "w-28 h-28" }) => (
  <div className={`relative grid place-items-center rounded-full border-2 border-gold/70 bg-plum ${className}`}>
    <div className="absolute inset-1.5 rounded-full border border-gold/40" />
    <Crown className="absolute top-[14%] w-[26%] h-[16%]" />
    <span className="font-display italic font-bold gold-text text-[2.1em] tracking-tighter mt-3">LDM</span>
  </div>
);
